import React from 'react'
import Navbar from '../components/maketApp/site/Navbar'

import Footer from '../components/maketApp/site/Footer'
import Contact from '../components/maketApp/site/Contact'
import HerosContact from '../components/maketApp/site/HerosContact'



const ContactPages = () => {


  return (
    <div>
       <Navbar />
   
   <HerosContact />
     
        <Contact />
         <Footer />
    </div>
  )
}

export default ContactPages
